import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// 扩展 dayjs 功能
const extendDayjs = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
};

// 初始化 dayjs
extendDayjs();

export default dayjs;
